import { proxy } from "valtio";
import { cargoStore, configStore, containerStore, contractsStore } from "../state/CommonState";
import { AirQuoteCharges, FCLQuoteCharges, QuoteCharges1 } from "../state/Types";
import Utils from "../util/Utils";
import { containerTypeweights } from "../StaticData";

const airChargesBookingStore = proxy({
  newRec: new AirQuoteCharges(),
  checktotal:0,
  list: [],
  initialLength: 0,
  calculateChargesTotalsindex: (key) => {
    try {
      airChargesBookingStore[key].map((e, i) => {
        if (
          (e.perKg != 0 || e.minimum != 0 || e.perAWB != 0) &&
          e?.currency === ""
        )
          throw new Error("Please select currency type.");
        let erate = configStore.getExchangeRateinr(e);
        if (!erate || erate === 0) erate = 1.0;
        erate = 1.0; // nullifying conversion for per row totals
        if (!e.perKg) e.perKg = 0;
        if (!e.minimum) e.minimum = 0;
        if (!e.perAWB) e.perAWB = 0;
        let z = {
          perKg : 0,
          minimum : 0,
          perAWB : 0
        }
        let l = ""
        let k = ["perKg","minimum","perAWB"]
        k.map((i)=>{
          if(Number(e[i])<0){
            l = "-"
            z[i] = Number(e[i]) * -1;
          }else{
            z[i] = Number(e[i])
          }
        })
        k.map((i)=>{
          if(Number(e[i])>0 && l=="-"){
            e[i] = -Number(e[i])
          }
        })
        let tots = cargoStore.totals;
        let val = Number(z.perKg) * Number(tots.totChargeableWeight);
        let temp = Number(z.minimum);
        if (temp > val) val = temp;
        if(l=="-"){
          e.total = -Utils.R((Number(val) + Number(z.perAWB)) * erate);
        }else{
          e.total = Utils.R((Number(val) + Number(z.perAWB)) * erate);
        }
      });
    } catch (error) {
      configStore.setModalMessage(error?.message || error);
    }
  }
});

const chargesBookingStore1 = proxy({
  newRec: new QuoteCharges1(),
  list: [],
  pkb: [],
  rebate: [],
  initialLength: 0,
  checktotal:0,
  calculateLCLChargesTotals: () => {
    let voldis = 0
    try {
      chargesBookingStore1.list.map((e, i) => {
        if (
          (e.perCBM > 0 ||
            e.perTon > 0 ||
            e.minimum > 0 ||
            e.maximum > 0 ||
            e.perShipment > 0) &&
          e?.currency === ""
        )
          throw new Error("Please select currency type.");
        if(e.chargeDescription != 'Marine Insurance'){
        let erate = configStore.getExchangeRateinr(e);
        if (!erate || erate === 0) erate = 1.0;
        erate = 1.0; // nullifying the rate.
        if (!e.perCBM) e.perCBM = 0;
        if (!e.perTon) e.perTon = 0;
        if (!e.minimum) e.minimum = 0;
        if (!e.maximum) e.maximum = 0;
        if (!e.perShipment) e.perShipment = 0;

        console.log('\n\n\n////////////////////////////\nAbout to recalculate', e.chargeDescription)
        let z = {
          perCBM : 0,
          perTon : 0,
          minimum : 0,
          maximum : 0,
          perShipment : 0
        }
        let l = ""
        let k = ["perCBM","perTon","minimum","maximum","perShipment"]
        k.map((i)=>{
          if(Number(e[i])<0){
            l = "-"
            z[i] = Number(e[i]) * -1;
          }else{
            z[i] = Number(e[i])
          }
        })
        k.map((i)=>{
          if(Number(e[i])>0 && l=="-"){
            e[i] = -Number(e[i])
          }
        })
        let tots = cargoStore.totals;
        console.log(e.perCBM, e.perTon, tots.totTotalVolume, tots.totTotalWeight)
        let val = Number(z.perCBM) * Number(tots.totTotalVolume);
        let temp = (Number(z.perTon) * Number(tots.totTotalWeight)) / 1000;
        if (temp > val) val = temp;
        temp = Number(z.minimum);
        if (temp > val) val = temp;
        temp = Number(z.maximum);
        if (temp != 0 && temp < val) val = temp;
        if(l=="-"){
          e.total = -Utils.R((Number(val) + Number(z.perShipment)) * erate);
        }else{
          e.total = Utils.R((Number(val) + Number(z.perShipment)) * erate);
        }

        console.log('Charge total=', e.total)
      }
        // if (e.chargeDescription == 'Ocean Freight') {
        //   console.log('got to OF')
        //   if (e.perCBM < 0 || e.perTon < 0 || e.minimum < 0 || e.maximum < 0) {
        //     console.log('something is < 0')
        //     let val = Number(e.perCBM) * Number(tots.totTotalVolume);
        //     let temp = (Number(e.perTon) * Number(tots.totTotalWeight)) / 1000;
        //     if (temp < val) val = temp;
        //     temp = Number(e.minimum);
        //     if (temp < val) val = temp;
        //     temp = Number(e.maximum);
        //     if (temp != 0 && temp > val) val = temp;
        //     e.total = Utils.R((Number(val) + Number(e.perShipment)) * erate);
        //     console.log('the revised e.tota =', e.total)
        //     if (e.total <= 0) {
        //       e.currency = 'USD'
        //       let oldtotal = e.total
        //       let tons = tots.totTotalWeight / 1000
        //       e.total = tots.totTotalVolume > tons ? tots.totTotalVolume : tons
        //       if (e.total < 1) e.total = 1
        //       console.log('\n\n\n*** e.total=', e.total, e.currency)
        //       voldis = oldtotal - e.total
        //     }
        //   }
        // }
      })
      chargesBookingStore1.list = chargesBookingStore1.list.filter(e => e.chargeDescription != 'Volume Discount')
      if (voldis != 0) {
        chargesBookingStore1.list.push({
          chargeDescription: 'Volume Discount',
          onaccount: 'On Your Account',
          currency: 'USD',
          perShipment: voldis,
          total: voldis
        })
      }
    } catch (error) {
      configStore.setModalMessage(error?.message || error);
    }
  },
  calculateLCLotherChargesTotals: (key) => {
    try {
      chargesBookingStore1[key].map((e, i) => {
        if (
          (e.perCBM > 0 ||
            e.perTon > 0 ||
            e.minimum > 0 ||
            e.maximum > 0 ||
            e.perShipment > 0) &&
          e?.currency === ""
        )
          throw new Error("Please select currency type.");
        let erate = configStore.getExchangeRateinr(e);
        if (!erate || erate === 0) erate = 1.0;
        erate = 1.0; // nullifying the rate.
        if (!e.perCBM) e.perCBM = 0;
        if (!e.perTon) e.perTon = 0;
        if (!e.minimum) e.minimum = 0;
        if (!e.maximum) e.maximum = 0;
        if (!e.perShipment) e.perShipment = 0;

        console.log('\n\n\n////////////////////////////\nAbout to recalculate', e.chargeDescription)
        let z = {
          perCBM : 0,
          perTon : 0,
          minimum : 0,
          maximum : 0,
          perShipment : 0
        }
        let l = ""
        let k = ["perCBM","perTon","minimum","maximum","perShipment"]
        k.map((i)=>{
          if(Number(e[i])<0){
            l = "-"
            z[i] = Number(e[i]) * -1;
          }else{
            z[i] = Number(e[i])
          }
        })
        k.map((i)=>{
          if(Number(e[i])>0 && l=="-"){
            e[i] = -Number(e[i])
          }
        })
        let tots = cargoStore.totals;
        console.log(e.perCBM, e.perTon, tots.totTotalVolume, tots.totTotalWeight)
        let val = Number(z.perCBM) * Number(tots.totTotalVolume);
        let temp = (Number(z.perTon) * Number(tots.totTotalWeight)) / 1000;
        if (temp > val) val = temp;
        temp = Number(z.minimum);
        if (temp > val) val = temp;
        temp = Number(z.maximum);
        if (temp != 0 && temp < val) val = temp;
        if(l=="-"){
          e.total = -Utils.R((Number(val) + Number(z.perShipment)) * erate);
        }else{
          e.total = Utils.R((Number(val) + Number(z.perShipment)) * erate);
        }

        console.log('Charge total=', e.total)
      })
    } catch (error) {
      configStore.setModalMessage(error?.message || error);
    }
  }
});

const fclChargesBookingStore = proxy({
  newRec: new FCLQuoteCharges(),
  list: [],
  initialLength: 0,
  costlist: [], // Cost Rate table in Create Booking → FCL charges (EditCharge)
  initialLengthcost: 0,
  calculateChargesTotalsindex: (index,emptycontainerweight,x) => {
    try { 
      fclChargesBookingStore[index].map((e, i) => {
        if (
          Object.entries(e)
            .filter(
              ([key, value]) => !isNaN(value) && key.toLowerCase() !== "id"
            )
            .some(([key, value]) => value > 0) &&
          e?.currency === ""
        )
          throw new Error("Please select currency type.");
        let l = ""
        let erate = configStore.getExchangeRateinr(e);
        if (!erate || erate === 0) erate = 1.0;
        erate = 1.0; // nullifying the per row conversion.
        containerStore.list.map((e1) => {
          console.log(e1,emptycontainerweight)
          let c = e1.containerType;
          let perwmField = c + "perWM";
          let pershipmentField = c + "perShipment";
          let totalField = c + "total";
          let perTonField = c + "perTon";
          if (!e[perwmField]) e[perwmField] = 0;
          if (!e[pershipmentField]) e[pershipmentField] = 0;
          if (!e[totalField]) e[totalField] = 0;
          if (!e[perTonField]) e[perTonField] = 0;
          let z = {}
          z[perwmField] = e[perwmField];
          z[pershipmentField] = e[pershipmentField];
          z[perTonField] = e[perTonField];
          let k = [c + "perWM",c + "perShipment",c + "perTon"]
          k.map((i)=>{
            if(Number(e[i])<0){
              l = "-"
              z[i] = Number(e[i]) * -1;
            }else{
              z[i] = Number(e[i])
            }
          })
          k.map((i)=>{
            if(Number(e[i])>0 && l=="-"){
              e[i] = -Number(e[i])
            }
          })
          let perwm = Number(z[perwmField]);
          let pership = Number(z[pershipmentField]);
          let num = Number(e1.numContainers) || 0;
          if(emptycontainerweight!=undefined && emptycontainerweight=='yes'){
            let perTonField = c + "perTon";
            if (!z[perTonField]) z[perTonField] = 0;
            let perton = Number(z[perTonField]);
            let wpc = Number(e1.wtPerContainer) || 0;
            let ecw = containerTypeweights[e1.containerType]["KG"]
            if(l=="-"){
              e[totalField] = -Utils.R((perwm * num) + pership + ((num * (wpc+ecw) * perton)/1000) * erate);
            }else{
              e[totalField] = Utils.R((perwm * num) + pership + ((num * (wpc+ecw) * perton)/1000) * erate);
            }
          }else{
            if(l=="-"){
              e[totalField] = -Utils.R((perwm * num + pership) * erate);
            }else{
              e[totalField] = Utils.R((perwm * num + pership) * erate);
            }
          }
          if(x == "quote" && fclChargesBookingStore[index].length === i+1 ){
          return true
          }
        });
      });
    } catch (error) {
       configStore.setModalMessage(error?.message || error);
       if(x == "quote"){
        return false
       }
    }
  },
  actcalculateChargesTotals: (emptycontainerweight,x) => {
    try { 
      fclChargesBookingStore.list.map((e, i) => {
        if (
          Object.entries(e)
            .filter(
              ([key, value]) => !isNaN(value) && key.toLowerCase() !== "id"
            )
            .some(([key, value]) => value > 0) &&
          e?.currency === ""
        )
          throw new Error("Please select currency type.");
        let l = ""
        let erate = configStore.getExchangeRateinr(e);
        if (!erate || erate === 0) erate = 1.0;
        erate = 1.0; // nullifying the per row conversion.
        containerStore.list.map((e1) => {
          console.log(e1,emptycontainerweight)
          let c = e1.containerType;
          let perwmField = c + "perWM";
          let pershipmentField = c + "perShipment";
          let totalField = c + "total";
          let perTonField = c + "perTon";
          if (!e[perwmField]) e[perwmField] = 0;
          if (!e[pershipmentField]) e[pershipmentField] = 0;
          if (!e[totalField]) e[totalField] = 0;
          if (!e[perTonField]) e[perTonField] = 0;
          let z = {}
          z[perwmField] = e[perwmField];
          z[pershipmentField] = e[pershipmentField];
          z[perTonField] = e[perTonField];
          let k = [c + "perWM",c + "perShipment",c + "perTon"]
          k.map((i)=>{
            if(Number(e[i])<0){
              l = "-"
              z[i] = Number(e[i]) * -1;
            }else{
              z[i] = Number(e[i])
            }
          })
          k.map((i)=>{
            if(Number(e[i])>0 && l=="-"){
              e[i] = -Number(e[i])
            }
          })
          let perwm = Number(z[perwmField]);
          let pership = Number(z[pershipmentField]);
          let num = Number(e1.numContainers) || 0;
          if(emptycontainerweight!=undefined && emptycontainerweight=='yes'){
            let perton = Number(z[perTonField]);
            let wpc = Number(e1.wtPerContainer) || 0;
            let ecw = containerTypeweights[e1.containerType]["KG"]
            if(l=="-"){
              e[totalField] = -Utils.R((perwm * num) + pership + ((num * (wpc+ecw) * perton)/1000) * erate);
            }else{
              e[totalField] = Utils.R((perwm * num) + pership + ((num * (wpc+ecw) * perton)/1000) * erate);
            }
          }else{
            if(l=="-"){
              e[totalField] = -Utils.R((perwm * num + pership) * erate);
            }else{
              e[totalField] = Utils.R((perwm * num + pership) * erate);
            }
          }
          if(x == "quote" && fclChargesBookingStore.list.length === i+1 ){
          return true
          }
        });
      });
    } catch (error) {
       configStore.setModalMessage(error?.message || error);
       if(x == "quote"){
        return false
       }
    }
  },
  defaultValueCalcindex: (index) => { // Initial value calculation for validation
    fclChargesBookingStore[index].map((e) => {
      containerStore.list.map((e1) => {
        let c = e1.containerType;
        let perwmField = c + "perWM";
        let pershipmentField = c + "perShipment";
        let totalField = c + "total";
        if (!e[perwmField]) e[perwmField] = 0;
        if (!e[pershipmentField]) e[pershipmentField] = 0;
        if (!e[totalField]) e[totalField] = 0;
      });
    })
  }
});

const chargesShipmentType = (lindex, index) => {
  const type = contractsStore.current?.shipmentType
  if (type) return type.toLowerCase()
  const fclRow = fclChargesBookingStore[lindex]?.[index]
  if (fclRow && containerStore.list.some((c) => (c.containerType + "perWM") in fclRow)) return "fcl"
  if (airChargesBookingStore[lindex]?.[index]) return "air"
  if (lindex === "list" && chargesBookingStore1.list[index]) return "lcl"
  return ""
}

const chargesBookingValidationStore = proxy({
  isNew: false,
  isValidCharge: (key, index, lindex="list") => {
    if (chargesBookingValidationStore.isNew) return true;
    let value;
    let containerKey = ["perWM", "perShipment","perTon"];
    let containerList = []
    if(containerStore.list.length > 0) containerKey.forEach((key) =>
    containerStore.list.forEach((ele) => containerList.push(ele.containerType + key)))
    const shipmentType = chargesShipmentType(lindex, index)
    if (!shipmentType) return true;
    if (shipmentType.includes("lcl")) {
      const cond = [
        // "Origin Charges",
        "Ocean Freight",
        // "Destination Charges",
      ].includes(chargesBookingStore1.list[index]?.chargeDescription);
      const total = chargesBookingStore1.list[index]['total'];
      switch (key) {
        case "perCBM":
        case "perTon":
        case "minimum":
          value = chargesBookingStore1.list[index][key];
          return cond
          ? true // umakanth - value !== null && value !== "" && value != 0
          : ["perCBM", "perTon", "minimum", "maximum"]
              // .filter((val) => val !== key)
              .some(
                (val) =>
                  // chargesBookingStore1.list[index][val] != "" ||
                  parseFloat(chargesBookingStore1.list[index][val]) != 0
              )
          ? value !== null && value != "" && parseFloat(value) >= 0
           : true;
        case "chargeDescription": 
          value = chargesBookingStore1.list[index][key];
          return !total || (value !== null && value !== "" && value != undefined)
        case "onaccount": 
          value = chargesBookingStore1.list[index][key];
          return value !== null && value !== "" && value != undefined
        case "currency":
          value = chargesBookingStore1.list[index][key];
          return cond
          ? value !== null && value !== "" && value != 0
          : ["perCBM", "perTon", "minimum", "maximum","perShipment"]
              .some(
                (val) =>{
                  if(val=="perShipment"){
                    if(isNaN(parseFloat(chargesBookingStore1.list[index][val]))){
                      return false
                    }
                  }
                  return parseFloat(chargesBookingStore1.list[index][val]) != 0
                }
              )
          ? value !== null && value != "" && parseFloat(value) != 0
           : true;
        default:
          return true;
      }
    } else if (shipmentType.includes("fcl")) {
      const cond = [
        //"Ocean Freight",
      ].includes(fclChargesBookingStore[lindex][index]?.chargeDescription);
      switch (key) {
        case "chargeDescription": 
          value = fclChargesBookingStore[lindex][index][key];
          return value !== null && value !== "" && value != undefined
        case "onaccount": 
          value = fclChargesBookingStore[lindex][index][key];
          return value !== null && value !== "" && value != undefined
        case "currency":
          value = fclChargesBookingStore[lindex][index][key];
          if(cond){
            return value !== null && value !== "" && parseFloat(value) != 0;
          }else if(containerList
            .some(
              (val) =>
              {
                if(val.includes("perTon")){
                  if(isNaN(parseFloat(fclChargesBookingStore[lindex][index][val]))){
                    return false
                  }
                }
                return parseFloat(fclChargesBookingStore[lindex][index][val]) != 0
              }
            )){
              return  value !== null && value != "" && parseFloat(value) != 0
          }else{
            return true;
          }
          default:
          if(key.includes("perWM")){
            value = fclChargesBookingStore[lindex][index][key];
            if(cond){
              return value !== null && value !== "" && value != undefined && parseFloat(value) != 0
            }else{
              return value !== "" && parseFloat(value) >= 0
            }
          }
          // if(key.includes("perTon")){
          //   value = fclChargesBookingStore[lindex][index][key];
          //   if(cond){
          //     return value !== null && value !== "" && value != undefined && parseFloat(value) > 0
          //   }else{
          //     return value !== "" && value >= 0
          //   }
          // } 
          if(key.includes("perShipment")){
            if(fclChargesBookingStore[lindex][index]?.disabled) return true;
            value = fclChargesBookingStore[lindex][index][key];
            if(cond){
              return value !== null && value !== "" && value != undefined
            }else{
              return value !== "" && parseFloat(value) >= 0
            }
          }
          return true;
      }
    } else if (shipmentType.includes("air")) {
      const cond = [
        "Air Freight"
      ].includes(airChargesBookingStore[lindex][index]?.chargeDescription);
      switch (key) {
        case "perKg":
        case "minimum":
          value = airChargesBookingStore[lindex][index][key];
          return cond
          ? true
          : ["perKg", "minimum"]
              .some(
                (val) =>
                  parseFloat(airChargesBookingStore[lindex][index][val]) != 0
              )
          ? value !== null && value != "" && parseFloat(value) > 0
           : true;
        case "chargeDescription": 
          value = airChargesBookingStore[lindex][index][key];
          return value !== null && value !== "" && value != undefined
        case "onaccount": 
          value = airChargesBookingStore[lindex][index][key];
          return value !== null && value !== "" && value != undefined
        case "currency":
          value = airChargesBookingStore[lindex][index][key];
          return cond
          ? value !== null && value !== "" && value != 0
          : ["perAWB", "perKg", "minimum"]
              .some(
                (val) =>
                  parseFloat(airChargesBookingStore[lindex][index][val]) != 0
              )
          ? value !== null && value != "" && parseFloat(value) != 0
           : true;
        default:
          return true;
      }
    }
  },
  isValidChargelclform: (key, index, list) => {
    if (chargesBookingValidationStore.isNew) return true;
    let value;
    if(list!=undefined && list[index]!=undefined && ["perCBM", "perTon", "minimum", "maximum","perShipment"].indexOf(key)!=-1 && list[index][key]!=undefined && list[index][key]==""){
      list[index][key] = 0
    }
    let total = 0
    if(list!=undefined && list[index]!=undefined && list[index]['total']!=undefined){
      total = list[index]['total']
    }
    // Only the LCL charge forms call this, so a not-yet-loaded contract is treated as LCL
    if ((contractsStore.current?.shipmentType || "lcl").toLowerCase().includes("lcl") && list!=undefined && list[index]!=undefined) {
      const cond = [
        "Ocean Freight",
      ].includes(list[index]?.chargeDescription);
      switch (key) {
        case "perCBM":
        case "perTon":
        case "minimum":
          value = list[index][key];
          return cond || list[index]['perShipment']
          ? true
          : ["perCBM", "perTon", "minimum", "maximum"]
              .some(
                (val) =>
                  parseFloat(list[index][val]) != 0
              )
          ? value !== null && value != "" && parseFloat(value) >= 0
           : true;
        case "chargeDescription": 
          value = list[index][key];
          return !total || (value !== null && value !== "" && value != undefined)
        case "onaccount": 
          value = list[index][key];
          return value !== null && value !== "" && value != undefined
        case "currency":
          value = list[index][key];
          return cond
          ? value !== null && value !== "" && value != 0
          : ["perCBM", "perTon", "minimum", "maximum","perShipment"]
              .some(
                (val) =>{
                  if(val=="perShipment"){
                    if(isNaN(parseFloat(list[index][val]))){
                      return false
                    }
                  }
                  return parseFloat(list[index][val]) != 0
                }
              )
          ? value !== null && value != "" && parseFloat(value) != 0
           : true;
        default:
          return true;
      }
    }
  }
});

export {airChargesBookingStore,chargesBookingValidationStore,chargesBookingStore1,fclChargesBookingStore};